import { createStaticStore, StaticStore } from "@/lib/store-factory"
import { endpoints } from "@/config/endpoints.config"
import { client } from "@/hooks/useClient"
import { store } from "./stores"
import { z } from "zod"
import { NamedEntitySchema } from "@/lib/schemas"
import { toast } from "sonner"

// ███████╗ ██████╗██╗  ██╗███████╗███╗   ███╗ █████╗
// ██╔════╝██╔════╝██║  ██║██╔════╝████╗ ████║██╔══██╗
// ███████╗██║     ███████║█████╗  ██╔████╔██║███████║
// ╚════██║██║     ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══██║
// ███████║╚██████╗██║  ██║███████╗██║ ╚═╝ ██║██║  ██║
// ╚══════╝ ╚═════╝╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚═╝  ╚═╝
//
export const UserSchema = NamedEntitySchema.extend({
  avatar: z.string(),
  email: z.string().email(),
  emailVerified: z.boolean(),
  role: z.string().default("member"),
  status: z.enum(["active", "inactive", "pending"]),
})

export type User = z.infer<typeof UserSchema>

export const InviteUserSchema = UserSchema.pick({ email: true })
export const EditUserSchema = UserSchema.pick({ role: true })

// ███████╗████████╗ ██████╗ ██████╗ ███████╗
// ██╔════╝╚══██╔══╝██╔═══██╗██╔══██╗██╔════╝
// ███████╗   ██║   ██║   ██║██████╔╝█████╗
// ╚════██║   ██║   ██║   ██║██╔══██╗██╔══╝
// ███████║   ██║   ╚██████╔╝██║  ██║███████╗
// ╚══════╝   ╚═╝    ╚═════╝ ╚═╝  ╚═╝╚══════╝
//
interface UserActions {
  invite: (dto: z.infer<typeof InviteUserSchema>) => Promise<User>
}
export interface UserStore extends StaticStore<User, UserActions> { }

export const userStore: UserStore = createStaticStore<User, UserActions>(
  {
    endpoint: endpoints.USERS,
  },
  {
    invite: (dto) => {
      return client.post<User>(endpoints.INVITE, dto).then((res) => {
        toast.success("Invitation sent to " + dto.email)
        return store.user.actions.addLocal(res.data)
      })
    },
  },
)
